/**
 * Tillåter servicekostnadsrapport om användaren har rapport-featuren
 * eller full service-modul (samma vy som under /service).
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/store/authStore';
import { ROUTES } from '@/constants/routes';
import { usePermissions } from '@/hooks/usePermissions';

const FEATURE_REPORT = 'REPORTS_SERVICE_COSTS';
const FEATURE_SERVICE = 'SYSTEM_SERVICE';

interface Props {
  children: React.ReactNode;
}

const ServiceCostsReportGate = ({ children }: Props) => {
  const { user, isAuthenticated } = useAuth();
  const { hasFeatureAccess, isLoading, permissions } = usePermissions();

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (user.is_global_admin) {
    return <>{children}</>;
  }

  if (isLoading || !permissions) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bgPrimary" />
      </div>
    );
  }

  if (hasFeatureAccess(FEATURE_REPORT) || hasFeatureAccess(FEATURE_SERVICE)) {
    return <>{children}</>;
  }

  return <Navigate to={ROUTES.DASHBOARD} replace />;
};

export default ServiceCostsReportGate;
